const clientSettings = {
    "Datumart": {
      "title": "Datumart Store Console",
      "favicon": "/datumart-favicon.ico",
    },
    "CholaCafe Bentonville": {
      "title": "CholaCafe Bentonville Store Console",
      "favicon": "/cholacafe-favicon.ico",
    },
    "Croydon Food Station": {
      "title": "Croydon Food Station Store Console",
      "favicon": "/croydon-favicon.ico",
    },
    "Anjappar Eastham": {
      "title": "Anjappar Eastham Store Console",
      "favicon": "/anjapparUK-favicon.ico",
    },
    "AnjapparUK Wimbledon": {
      "title": "AnjapparUK Wimbledon Store Console",
      "favicon": "/anjapparUK-favicon.ico",
    },
    "RajaVidyalaya Digital": {
      "title": "RajaVidyalaya Digital Store Console",
      "favicon": "/rajavidyalaya-favicon.ico",
    },
    "Stynt.ai": {
      "title": "Stynt.ai Store Console",
      "favicon": "/stynt.ai-favicon.ico",
    }
  };
  
  export default clientSettings;
  